import { Model } from '@vuex-orm/core'

export default class UserEvent extends Model {
    
    static entity = 'user_event'
  
    static primaryKey = ['user_id', 'event_id']
  
    static fields () {
        return {
            user_id: this.attr(null),
            event_id: this.attr(null)
        }
    }
}